import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

type Options = {
  enabled?: boolean;
  /** Optional `id=eq.…` for detail page. */
  filter?: string;
  onChange?: () => void;
};

/**
 * Live-refresh DEM blanket orders / lines / movements.
 * Requires migration 268.
 */
export function useDemBlanketOrdersRealtime(options: Options = {}) {
  const { enabled = true, filter, onChange } = options;

  usePostgresChangesRealtime({
    enabled,
    channelName: filter ? `dem-blanket-live:${filter}` : 'dem-blanket-live',
    portalKind: 'dem',
    syncSecondaryAuth: true,
    debounceMs: 400,
    onChange,
    listens: [
      { schema: 'data_entry_management', table: 'blanket_orders', ...(filter ? { filter } : {}) },
      { schema: 'data_entry_management', table: 'blanket_order_lines' },
      { schema: 'data_entry_management', table: 'blanket_order_movements' },
    ],
  });
}
